import { useEffect, useMemo, useState } from "react";
import { Link } from "react-router-dom";
//-------------------------------------------
import { useMyStore } from "src/components/main/mainStore";
import Resize from "src/components/common/resize";
import { 
    arrayReducer, getDatefromWeekNum, myAxios, 
    MyDate, MyFormData, Select, weeknum, getDatefromWeekNum0, 
    getDateEndFromWeekNum, numberReducer, onlyUnique, 
    appTitle
} from "src/components/common/functions";
import Export from "./export";
import Chart from "./chart";
//-------------------------------------------
// this is for project stage color:
// 255, 99, 132 red
// 54, 162, 235 blue
// 255, 206, 86 yellow
// 75, 192, 192 green
// 153, 102, 255 purple
// 255, 159, 64 orange
// 127, 188, 65 grass green
// 50, 136, 189 dark blue
// 94, 79, 162 dark purple
//purchase category color 7 out of 9
//-------------------------------------------
export default function ProfitMargin({ tabTitle }){
    const user = useMyStore(state => state.user);
    const combineLines = (arr, options) => {
        const output = [];
        const points = arr.reduce(arrayReducer, []);
        const xs = Array.from(new Set(points.map(point => point[0]))).sort();
        for(let i = 0; i < xs.length; i++){
            const x = xs[i];
            let sum = 0;
            for(let j = 0; j < arr.length; j++){
                const line = arr[j];
                const option = options[j];
                for(let k = 0; k < line.length; k++){
                    if(x <= line[k][0]){
                        if(k > 0){
                            const start = line[k - 1];
                            const end = line[k];
                            const ratio = (end[1] - start[1]) / ((new Date(end[0])) - (new Date(start[0])));
                            const cur = ratio * ((new Date(x)) - (new Date(start[0]))) + start[1];
                            if(option === "+"){
                                sum += cur;
                            }else if(option === "-"){
                                sum -= cur;
                            }
                        }
                        break;
                    }
                }
            }
            output.push([x, Math.round(sum)]);
        }
        return output;
    }
    const convertProjectPoints = (budgetsStr) => {
        const output = [];
        if(!budgetsStr) return output;
        const arr = JSON.parse(budgetsStr);
        if(!arr[0].amount) return output;
        let acc = 0;
        
        for(let i = 0; i < arr.length; i++){
            acc += window.parseFloat(arr[i].amount);
            const start = i === 0?arr[i].start: arr[i - 1].end;
            if(arr[i].end){
                output.push([start, arr[i].amount], [arr[i].end, acc]);
            }else{
                output.push([start, arr[i].amount]);
            }
        }
        return output;
    }
    const changeDatebyDay = (dateStr, offset) => {
        const date = new MyDate(dateStr.replace(/-/g,"/"));
        date.setDate(date.getDate() + offset);
        return date.s();
    }
    //-------------------------------------------------------------------------
    const [week, setWeek] = useState("");
    const [oh, setOH] = useState(1.54);
    const [showLoading, setShowLoading] = useState(false);
    const [projects, setProjects] = useState([]);
    const [laborCosts, setLaborCosts] = useState({});
    const [importedBillings, setImportedBillings] = useState({});
    const [purchases, setPurchases] = useState([]);
    const [reportHours, setReportHours] = useState("0.00h");
    const [curProjectHashKey, setProjectHashKey] = useState("");
    const [curProjectManagerEmail, setProjectManagerEmail] = useState("");
    const [startDate, setStartDate] = useState("");
    const [endDate, setEndDate] = useState("");
    const [managers, setManagers] = useState([]);
    const weeks = useMemo(() => {
            const dateIterator = new MyDate("2023/1/2");
            const dateArray = [];
            while(dateIterator < getDatefromWeekNum0(weeknum(new MyDate()), 0)){
                const weekNum = weeknum(dateIterator);
                if(weekNum in laborCosts || weekNum in importedBillings) dateArray.push(weekNum);
                dateIterator.setDate(dateIterator.getDate() + 7);
            }
            return dateArray;
    }, [laborCosts, importedBillings]);
    const p = useMemo(() => {
        if(!curProjectHashKey) return [];
        const project = projects.find(localProject => localProject.value === curProjectHashKey);
        // if(!project) return [];
        return convertProjectPoints(project.budgets);
    }, [projects, curProjectHashKey]);
    const pur = useMemo(() => {
        const output = [];
        const localPurchases = purchases;
        if(localPurchases.length){
            output.push(
                [changeDatebyDay(localPurchases[0].poDate, -1), 0],
                [localPurchases[0].poDate, window.parseFloat(localPurchases[0].total)]
            );
            if(localPurchases.length > 1){
                for(let i = 1; i < localPurchases.length; i++){
                    const prePurchase = localPurchases[i - 1];
                    const purchase = localPurchases[i];
                    if(prePurchase.poDate === purchase.poDate){
                        output[output.length - 1][1] = output[output.length - 1][1] + window.parseFloat(localPurchases[i].total);
                    }else{
                        output.push([
                            localPurchases[i].poDate, 
                            output[output.length - 1][1] + window.parseFloat(localPurchases[i].total)
                        ]);
                    }
                }
            }
        }
        return output;
    }, [purchases]);
    const pur1 = useMemo(() => {
        const output = [];
        const localPurchases = purchases.filter(purchase => 
            purchase.billable === "Yes"
        );
        if(localPurchases.length){
            output.push(
                [changeDatebyDay(localPurchases[0].poDate, -1), 0],
                [localPurchases[0].poDate, window.parseFloat(localPurchases[0].total)]
            );
            if(localPurchases.length > 1){
                for(let i = 1; i < localPurchases.length; i++){
                    const prePurchase = localPurchases[i - 1];
                    const purchase = localPurchases[i];
                    if(prePurchase.poDate === purchase.poDate){
                        output[output.length - 1][1] = output[output.length - 1][1] + window.parseFloat(localPurchases[i].total);
                    }else{
                        output.push([
                            localPurchases[i].poDate, 
                            output[output.length - 1][1] + window.parseFloat(localPurchases[i].total)
                        ]);
                    }
                }
            }
        }
        return output;
    }, [purchases]);
    const pur2 = useMemo(() => {
        const output = [];
        const localPurchases = purchases.filter(purchase => 
            purchase.billable === "No" && 
            purchase.includedInProposal === "Yes"
        );
        if(localPurchases.length){
            output.push(
                [changeDatebyDay(localPurchases[0].poDate, -1), 0],
                [localPurchases[0].poDate, window.parseFloat(localPurchases[0].total)]
            );
            if(localPurchases.length > 1){
                for(let i = 1; i < localPurchases.length; i++){
                    const prePurchase = localPurchases[i - 1];
                    const purchase = localPurchases[i];
                    if(prePurchase.poDate === purchase.poDate){
                        output[output.length - 1][1] = output[output.length - 1][1] + window.parseFloat(localPurchases[i].total);
                    }else{
                        output.push([
                            localPurchases[i].poDate, 
                            output[output.length - 1][1] + window.parseFloat(localPurchases[i].total)
                        ]);
                    }
                }
            }
        }
        return output;
    }, [purchases]);
    const pur3 = useMemo(() => {
        const output = [];
        const localPurchases = purchases.filter(purchase => 
            purchase.billable === "No" && 
            purchase.includedInProposal === "No"
        );
        if(localPurchases.length){
            output.push(
                [changeDatebyDay(localPurchases[0].poDate, -1), 0],
                [localPurchases[0].poDate, window.parseFloat(localPurchases[0].total)]
            );
            if(localPurchases.length > 1){
                for(let i = 1; i < localPurchases.length; i++){
                    const prePurchase = localPurchases[i - 1];
                    const purchase = localPurchases[i];
                    if(prePurchase.poDate === purchase.poDate){
                        output[output.length - 1][1] = output[output.length - 1][1] + window.parseFloat(localPurchases[i].total);
                    }else{
                        output.push([
                            localPurchases[i].poDate, 
                            output[output.length - 1][1] + window.parseFloat(localPurchases[i].total)
                        ]);
                    }
                }
            }
        }
        return output;
    }, [purchases]);
    const lc = (curProjectHashKey) => {
        const output = [];
        let acc = 0;
        Object.entries(laborCosts).forEach(([key, value]) => {
            const amount = value[curProjectHashKey];
            if(amount){
                if(acc === 0){
                    const curStart = getDatefromWeekNum(key, 0);
                    output.push([curStart, Math.round(acc)]);
                }
                acc += amount;
                const curEnd = getDatefromWeekNum(key, 6);
                output.push([curEnd, Math.round(acc)]);
            }   
            
        });
        return output;
    };
    const curlc = useMemo(() => lc(curProjectHashKey), [curProjectHashKey, laborCosts]);
    const ib = (curProjectHashKey) => {
        const output = [];
        let acc = 0;
        Object.entries(importedBillings).forEach(([key, value]) => {
            const amount = value[curProjectHashKey]?.map(item => item.amount).reduce(numberReducer, 0);
            if(amount){
                if(acc === 0){
                    const curStart = getDatefromWeekNum(key, 0);
                    output.push([curStart, Math.round(acc)]);
                }
                acc += amount;
                const curEnd = getDatefromWeekNum(key, 6);
                output.push([curEnd, Math.round(acc)]);
            }   
            
        });
        return output;
    };
    const curib = useMemo(() => ib(curProjectHashKey), [curProjectHashKey, importedBillings]);
    //---------------------------------------------------
    const tc = (curProjectHashKey) => polish(curProjectHashKey, lc(curProjectHashKey), ib(curProjectHashKey)).lc.map(([x, y]) => [x, Math.round(y * (window.parseFloat(oh || "1.54") + 1))]);
    const curtc = curlc.map(([x, y]) => [x, Math.round(y * (window.parseFloat(oh || "1.54") + 1))]);
    const profit = (curProjectHashKey) => combineLines([polish(curProjectHashKey, lc(curProjectHashKey), ib(curProjectHashKey)).ib, tc(curProjectHashKey)], ["+", "-"]);
    const curprofit = combineLines([curib, curtc], ["+", "-"]);
    //---------------------------------------------------
    const importBillingsProjects = Object.values(importedBillings).map(item => Object.keys(item)).reduce(arrayReducer, []).filter(onlyUnique);
    const laborCostProjects = Object.values(laborCosts).map(item => Object.keys(item)).reduce(arrayReducer, []).filter(onlyUnique);
    //---------------------------------------------------
    const filteredProjects = projects.filter(project => project.projectManagerEmail === curProjectManagerEmail && 
        (project.projectCreationDate && project.projectCreationDate >= startDate && project.projectCreationDate <= endDate) && 
        (project.projectDateUpdated && project.projectDateUpdated >= startDate && project.projectDateUpdated <= endDate)
    )
    const projectsMap = Object.fromEntries(projects.map(project => [project.value, project.label]));
    const getLastestValue = arr => {
        if(arr.length === 0) return "";
        return arr[arr.length - 1][1];
    };
    //-------------------------------------------------------------------------
    const polish = (curProjectHashKey, thislc, thisib) => {
        if(!curProjectHashKey || !thislc.length || !thisib.length) return {ib: [], lc: []};
        const lclast = thislc[thislc.length - 1];
        const blast = thisib[thisib.length - 1];
        const project = projects.find(localProject => localProject.value === curProjectHashKey);
        if(blast && lclast && blast[0] < lclast[0]){
            thisib.push([lclast[0], blast[1]]);
            if(project && project.budgets){
                const budget = JSON.parse(project.budgets);
                if(budget[budget.length - 1].endUnknown){
                    p.push([lclast[0], budget[budget.length - 1].amount])
                }
            }
        }else if(blast && lclast && blast[0] > lclast[0]){
            thislc.push([blast[0], lclast[1]]);
            if(project && project.budgets){
                const budget = JSON.parse(project.budgets);
                if(budget[budget.length - 1].endUnknown){
                    p.push([blast[0], budget[budget.length - 1].amount])
                }
            }
        }else if(blast){
            if(project && project.budgets){
                const budget = JSON.parse(project.budgets);
                if(budget[budget.length - 1].endUnknown){
                    p.push([blast[0], budget[budget.length - 1].amount])
                }
            }
        }else if(lclast){
            if(project && project.budget){
                const budget = JSON.parse(project.budgets);
                if(budget[budget.length - 1].endUnknown){
                    p.push([lclast[0], budget[budget.length - 1].amount])
                }
            }
        }else{
            if(project && project.budget){
                const budget = JSON.parse(project.budgets);
                if(budget[budget.length - 1].endUnknown){
                    p.push([(new MyDate()).s(), budget[budget.length - 1].amount])
                }
            }
        }
        const lcfirst = thislc[0];
        const bfirst = thisib[0];
        if(bfirst && lcfirst && bfirst[0] > lcfirst[0]){
            thisib.unshift([lcfirst[0], 0]);
        }else if(bfirst && lcfirst && bfirst[0] > lcfirst[0]){
            thislc.unshift([bfirst[0], 0]);
        }
        return {ib: thisib, lc: thislc};
    }
    
    useEffect(() => {polish(curProjectHashKey, curlc, curib);}, [projects, curProjectHashKey, laborCosts, importedBillings])
    useEffect(() => {
        let isMounted = true;
        const getData = async() => {
            const formData = new MyFormData();
            //-----------------------------------
            setShowLoading(true);
            const resProjects = await myAxios("profitMargin/readProjectNames.php", formData); 
            // project manager email
            // project created
            // project updated
            if(!isMounted) return;
            setShowLoading(false);
            if(!resProjects) return;
            //-----------------------------------
            setProjects(resProjects.data);
            //-----------------------------------
            setShowLoading(true);
            const resImportedBillings = await myAxios("profitMargin/readImportedBillings.php", formData);
            if(!isMounted) return;
            setShowLoading(false);
            if(!resImportedBillings) return;
            //-----------------------------------
            setImportedBillings(resImportedBillings.data);
            //-----------------------------------
            setShowLoading(true);
            const resLaborCost = await myAxios("profitMargin/readLaborCost.php", formData);
            if(!isMounted) return;
            setShowLoading(false);
            if(!resLaborCost) return;
            //-----------------------------------
            setLaborCosts(resLaborCost.data);
            //-----------------------------------
            setShowLoading(true);
            const resMangers = await myAxios("profitMargin/readProjectManagers.php", formData);
            if(!isMounted) return;
            setShowLoading(false);
            if(!resMangers) return;
            //-----------------------------------
            setManagers(resMangers.data);
        }
        getData();
        return () => {isMounted = false;}
    }, [])
    useEffect(() => {
        let isMounted = true;
        if(!curProjectHashKey) return;
        const getData = async() => {
            const formData = new MyFormData();
            formData.append("projectHashKey", curProjectHashKey);
            //-----------------------------------
            setShowLoading(true);
            const resPurchases = await myAxios("profitMargin/readPurchases.php", formData);
            if(!isMounted) return;
            setShowLoading(false);
            if(!resPurchases) return;
            //-----------------------------------
            if(!isMounted || !resPurchases) return;
            setPurchases(resPurchases.data);
            //-----------------------------------
            formData.append("projectHashKey", curProjectHashKey);
            //-----------------------------------
            setShowLoading(true);
            const resReports = await myAxios("profitMargin/readReports.php", formData);
            if(!isMounted) return;
            setShowLoading(false);
            if(!resReports) return;
            //-----------------------------------
            if(!isMounted || !resReports) return;
            setReportHours(resReports.data);
        }
        getData();
        return () => {isMounted = false;}
    }, [curProjectHashKey])
    useEffect(() => {
        document.title = tabTitle;
        return () => {
            document.title = appTitle;
        };
    }, [tabTitle]);
    //-------------------------------------------------------------------------
    return (
    <div>
        <div className = "cssTab">
            <div className = "cssHeader" style = {{background: user.userTheme}}>
                <span>
                    <Resize/>
                    {tabTitle}
                </span>
                <span></span>
                <span className = "d-flex align-items-center">
                    <label htmlFor = "oh" className = "mb-0">Over Head Ratio:</label>
                    <input
                        id = "oh"
                        type = "number" 
                        step = "0.01"
                        min = "0"
                        className = "form-control numberInputWidth ml-2" 
                        value = {oh}
                        onChange = {e => setOH(e.currentTarget.value)}
                    />
                </span>
            </div>
            <div className = "cssContent pb10">
                {showLoading?
                <div className = "cssLoading">Loading...</div>:
                <div>
                    <div className = "d-flex align-items-center mb-3 p-2 border rounded">
                        <label className = "mb-0 alignSelf-center">Export Week</label>
                        <div className = "mx-3 flex-grow-1 d-flex align-items-center">
                            <select
                                className = "form-control w-auto"
                                value = {week}
                                onChange = {e => {
                                    setWeek(e.currentTarget.value);
                                }}
                            >
                                <option value = "">Select</option>
                                {weeks.map((wk, key) => <option key = {key} value = {wk}>{getDateEndFromWeekNum(wk)}</option>)}
                            </select>
                            {week?
                            <Export
                                week = {week} 
                                weeks = {weeks} 
                                laborCosts = {laborCosts} 
                                projects = {projects} 
                                importedBillings = {importedBillings}  
                                oh = {oh} 
                            />
                            :<></>}
                        </div>
                    </div>
                    <div className = "d-flex align-items-center">
                        <label className = "mb-0 alignSelf-center">Project</label>
                        <div className = "mx-3 flex-grow-1">
                            <Select
                                value = {projects.find(x => x.value === curProjectHashKey)}
                                onChange = {e => {
                                    setProjectHashKey(e?.value ?? "");
                                }}
                                options = {projects.filter(project => importBillingsProjects.includes(project.value) || laborCostProjects.includes(project.value))}
                            />
                        </div>
                    </div>
                    {curProjectHashKey?
                    <div className = "flex-grow-1">
                        <Chart
                            chartConfig = {{
                                type: "line",
                                data: {
                                    labels: p.map(point => point[0]),
                                    datasets: [
                                    { 
                                        data: p.map(point => ({x: point[0], y: point[1]})),
                                        label: "Planned Value",
                                        borderDash: [10, 5], 
                                        borderColor: `rgba(153, 102, 255, 1)`,
                                        fill: false,
                                        tension: 0
                                    },
                                    { 
                                        data: curlc.map(point => ({x: point[0], y: point[1]})),
                                        label: "Labor Cost",
                                        borderColor: `rgba(75, 192, 192, 1)`,
                                        fill: false,
                                        tension: 0
                                    },
                                    { 
                                        data: curtc.map(point => ({x: point[0], y: point[1]})),
                                        label: "Estimate Total Cost",
                                        borderDash: [10, 5], 
                                        borderColor: `rgba(54, 162, 235, 1)`,
                                        fill: false,
                                        tension: 0
                                    },
                                    { 
                                        data: curib.map(point => ({x: point[0], y: point[1]})),
                                        label: "Billings",
                                        borderColor: `rgba(127, 188, 65, 1)`,
                                        fill: false,
                                        tension: 0
                                    },
                                    { 
                                        data: curprofit.map(point => ({x: point[0], y: point[1]})),
                                        label: "Profit",
                                        borderColor: `rgba(255, 159, 64, 1)`,
                                        fill: false,
                                        tension: 0
                                    }
                                ]
                                },
                                options: {
                                    hover: {
                                        mode: 'index',
                                        intersect: false
                                    },
                                    elements: {
                                        point:{
                                            radius: 0
                                        }
                                    },
                                    scales: {
                                        xAxes: [{
                                            type: "time",
                                            time: {
                                                displayFormats: {
                                                    'millisecond': 'MMM DD',
                                                    'second': 'MMM DD',
                                                    'minute': 'MMM DD',
                                                    'hour': 'MMM DD',
                                                    'day': 'MMM DD',
                                                    'week': 'MMM DD',
                                                    'month': 'MMM DD',
                                                    'quarter': 'MMM DD',
                                                    'year': 'MMM DD',
                                                }
                                            },
                                            tick: {
                                                unit: "day",
                                            },
                                            scaleLabel: {
                                                fontSize: 15,
                                                display: true,
                                                labelString: "Date"
                                            }
                                        }],
                                        yAxes: [{
                                            ticks: {
                                                precision: 0
                                            },
                                            scaleLabel: {
                                                fontSize: 15,
                                                display: true,
                                                labelString: "Amount ($)"
                                            }
                                        }]
                                    },
                                    title: {
                                        fontSize: 20,
                                        display: true,
                                        text: `Profit Margin`
                                    }
                                }
                            }}
                        />
                        {curprofit[curprofit.length - 1] && curib[curib.length - 1]?
                        <>
                        <div className = {`text-center h5 text-${curprofit[curprofit.length - 1]?.[1] > 0?"success":"danger"}`}>
                            Current Profit: {curprofit[curprofit.length - 1]?.[1]}
                        </div>
                        <div className = {`text-center h5 text-${curprofit[curprofit.length - 1]?.[1] > 0?"success":"danger"}`}>
                            Current Profit Margin: {((curprofit[curprofit.length - 1]?.[1] / curib[curib.length - 1]?.[1]) * 100).toFixed(2)}%
                        </div>
                        </>
                        :<></>}

                        {reportHours !== "0.00h"?
                        <div className = {`text-center h5`}>
                            Current Report Hours: {reportHours}
                        </div>
                        :<></>}

                        {p.length && (pur.length || pur1.lengthh || pur2.length || pur3.length)?
                        <Chart
                            chartConfig = {{
                                type: "line",
                                data: {
                                    labels: p.map(point => point[0]),
                                    datasets: [
                                    { 
                                        data: pur.map(point => ({x: point[0], y: point[1]})),
                                        label: "Material Cost",
                                        borderColor: `rgba(75, 192, 192, 1)`,
                                        fill: false,
                                        tension: 0,
                                    },
                                    { 
                                        data: pur1.map(point => ({x: point[0], y: point[1]})),
                                        label: "Billable",
                                        borderColor: `rgba(50, 136, 189, 1)`,
                                        fill: false,
                                        tension: 0,
                                    },
                                    { 
                                        data: pur2.map(point => ({x: point[0], y: point[1]})),
                                        label: "Non-Billable but Included In Proposal",
                                        borderColor: `rgba(94, 79, 162, 1)`,
                                        fill: false,
                                        tension: 0,
                                    },
                                    { 
                                        data: pur3.map(point => ({x: point[0], y: point[1]})),
                                        label: "Non-Billable",
                                        borderColor: `rgba(255, 99, 132, 1)`,
                                        fill: false,
                                        tension: 0,
                                    },
                                ]
                                },
                                options: {
                                    hover: {
                                        mode: 'index',
                                        intersect: false
                                    },
                                    elements: {
                                        point:{
                                            radius: 0
                                        }
                                    },
                                    scales: {
                                        xAxes: [{
                                            type: "time",
                                            time: {
                                                displayFormats: {
                                                    'millisecond': 'MMM DD',
                                                    'second': 'MMM DD',
                                                    'minute': 'MMM DD',
                                                    'hour': 'MMM DD',
                                                    'day': 'MMM DD',
                                                    'week': 'MMM DD',
                                                    'month': 'MMM DD',
                                                    'quarter': 'MMM DD',
                                                    'year': 'MMM DD',
                                                }
                                            },
                                            tick: {
                                                unit: "day",
                                            },
                                            scaleLabel: {
                                                fontSize: 15,
                                                display: true,
                                                labelString: "Date"
                                            }
                                        }],
                                        yAxes: [{
                                            ticks: {
                                                precision: 0
                                            },
                                            scaleLabel: {
                                                fontSize: 15,
                                                display: true,
                                                labelString: "Amount ($)"
                                            }
                                        }]
                                    },
                                    title: {
                                        fontSize: 20,
                                        display: true,
                                        text: `PO Breakdown`
                                    }
                                }
                            }}
                        />:<></>}

                    </div>
                    :null}
                    <div className = "mt-3 d-flex align-items-center">
                        <label className = "mb-0 alignSelf-center">Project Manager</label>
                        <div className = "mx-3 flex-grow-1">
                            <Select
                                value = {managers.find(x => x.value === curProjectManagerEmail)}
                                onChange = {e => {
                                    setProjectManagerEmail(e?.value ?? "");
                                }}
                                options = {managers}
                            />
                        </div>
                            <label className = "ml-4 mb-0 alignSelf-center text-nowrap" htmlFor = "startDate">Start Date</label>
                            <input
                                id = "startDate"
                                type = "date"
                                className = "ml-3 inline form-control"
                                value = {startDate}
                                onChange = {e => {
                                    setStartDate(e.currentTarget.value);
                                }}
                            />
                            <label className = "ml-4 mb-0 alignSelf-center text-nowrap" htmlFor = "endDate">End Date</label>
                            <input
                                id = "endDate"
                                type = "date"
                                className = "ml-3 inline form-control"
                                value = {endDate}
                                onChange = {e => {
                                    setEndDate(e.currentTarget.value);
                                }}
                            />
                    </div>
                    {curProjectManagerEmail && startDate && endDate?
                    (!filteredProjects.length?<div className = "cssLoading">There is no projects under this setting.</div>:
                    <table className = "table mt-3">
                        <thead>
                            <tr className = "stickyHeader">
                                <th>Project Name</th>
                                <th>Total Billing</th>
                                <th>Total Labor Cost</th>
                                <th>Total Estimate Cost</th>
                                <th>Total Estimate Profit</th>
                                <th>Total Estimate Profit Margin</th>
                            </tr>
                        </thead>
                        <tbody>
                            {filteredProjects
                            .map(({ value }, projectIndex) => 
                            <tr key = {projectIndex}> 
                                <th>
                                    <Link to = {`/Projects/${value}`}>
                                        {projectsMap[value]}
                                    </Link>
                                </th>
                                <th className = "text-center">
                                    {getLastestValue(polish(value, lc(value), ib(value)).ib)}
                                </th>
                                <th className = "text-center">
                                    {getLastestValue(polish(value, lc(value), ib(value)).lc)}
                                </th>
                                <th className = "text-center">
                                    {getLastestValue(tc(value))}
                                </th>
                                <th className = {"text-center" + (["", 0].includes(getLastestValue(profit(value)))?"":(getLastestValue(profit(value)) > 0?" text-success":" text-danger"))}>
                                    {getLastestValue(profit(value))}
                                </th>
                                <th className = {"text-center" + (["", 0].includes(getLastestValue(profit(value)))?"":(getLastestValue(profit(value)) > 0?" text-success":" text-danger"))}>
                                    {getLastestValue(polish(value, lc(value), ib(value)).ib)?(getLastestValue(profit(value)) / getLastestValue(polish(value, lc(value), ib(value)).ib) * 100).toFixed(2) + "%":""} 
                                </th>
                            </tr>
                            )}
                            <tr> 
                                <th>
                                    Total: {filteredProjects.length}
                                </th>
                                <th className = "text-center">
                                    {filteredProjects.map(({ value }) => window.Number.parseFloat(getLastestValue(polish(value, lc(value), ib(value)).ib) || "0")).reduce(numberReducer, 0)}
                                </th>
                                <th className = "text-center">
                                    {filteredProjects.map(({ value }) => window.Number.parseFloat(getLastestValue(polish(value, lc(value), ib(value)).lc) || "0")).reduce(numberReducer, 0)}
                                </th>
                                <th className = "text-center">
                                    {filteredProjects.map(({ value }) => window.Number.parseFloat(getLastestValue(tc(value)) || "0")).reduce(numberReducer, 0)}
                                </th>
                                <th className = {"text-center" + (["", 0].includes(filteredProjects.map(({ value }) => window.Number.parseFloat(getLastestValue(profit(value)) || "0")).reduce(numberReducer, 0))?"":(filteredProjects.map(({ value }) => window.Number.parseFloat(getLastestValue(profit(value)) || "0")).reduce(numberReducer, 0) > 0?" text-success":" text-danger"))}>
                                    {filteredProjects.map(({ value }) => window.Number.parseFloat(getLastestValue(profit(value)) || "0")).reduce(numberReducer, 0)}
                                </th>
                                <th className = {"text-center" + (["", 0].includes(filteredProjects.map(({ value }) => window.Number.parseFloat(getLastestValue(profit(value)) || "0")).reduce(numberReducer, 0))?"":(filteredProjects.map(({ value }) => window.Number.parseFloat(getLastestValue(profit(value)) || "0")).reduce(numberReducer, 0) > 0?" text-success":" text-danger"))}>
                                    {filteredProjects.map(({ value }) => window.Number.parseFloat(getLastestValue(polish(value, lc(value), ib(value)).ib) || "0")).reduce(numberReducer, 0)?
                                    (filteredProjects.map(({ value }) => window.Number.parseFloat(getLastestValue(profit(value)) || "0")).reduce(numberReducer, 0)
                                    /
                                    filteredProjects.map(({ value }) => window.Number.parseFloat(getLastestValue(polish(value, lc(value), ib(value)).ib) || "0")).reduce(numberReducer, 0)
                                    *
                                    100).toFixed(2) + "%":""}
                                </th>
                            </tr>
                        </tbody>
                    </table>)
                    :null}
                </div>
                }
            </div>
        </div>    
    </div>
    )
}